import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FloodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flood"}/>
}
